import React from "react";
import { useParams } from "react-router";
import { Breadcrumbs } from "@/shared/widgets/Breadcrumbs";
import { TabNavigationWrapperProps } from ".";
import { ScreenContainer } from "@/shared/ui/ScreenContainer";
import { TabNavigation } from "@/shared/widgets/TabNavigation";
import { useAccount } from "@/features/workspace/hooks/useAccount";
import { Column } from "@/shared/ui/Blocks";

export function AccountSettingsWrapper(props: TabNavigationWrapperProps) {
  const { accountId } = useParams();
  const { children, ...rest } = props;

  const { account } = useAccount();

  const tabs = [
    {
      id: "general",
      label: "General",
      path: `/account/${accountId}/settings`,
    },
    {
      id: "members",
      label: "Members",
      path: `/account/${accountId}/members`,
    },
    {
      id: "organisations",
      label: "Organisations",
      path: `/account/${accountId}/organisations`,
    },
    // {
    //   id: "billing",
    //   label: "Billing",
    //   path: `/account/${accountId}/billing`,
    // },
  ];

  return (
    <Column className="w-full relative ">
      <TabNavigation tabs={tabs} className="px-8 sticky top-0 bg-white z-10" />
      <Breadcrumbs
        items={[
          {
            icon: "Building",
            label: account?.name || "Workspace",
            path: `/account/${accountId}/settings`,
          },
        ]}
      />
      <ScreenContainer className="overflow-y-auto" {...rest}>
        {children}
      </ScreenContainer>
    </Column>
  );
}
